import MuiLink, { LinkProps as MuiLinkProps } from "@mui/material/Link";

export interface LinkProps extends MuiLinkProps {
  to?: string;
}

const Link: React.FC<LinkProps> = (props) => {
  return (
    <MuiLink underline="hover" {...props}>
      {props.children}
    </MuiLink>
  );
};

export default Link;
